(function(){
  // PERFORMANCE FIX: card-product.liquid's <script src="upk-pdp.js"> tag is
  // wrapped in {% unless skip_styles %}, and skip_styles correctly suppresses
  // repeats WITHIN one section's own product-card loop - but each section on
  // a page (Best Sellers, New Arrivals, Recently Viewed, etc.) resets that
  // flag independently, so a page with several such sections re-emits this
  // exact <script> tag once per section. On the homepage this file was
  // measured loading 4 separate times. Without a guard, every extra copy
  // re-declares every function above from scratch AND re-registers a new
  // 'shopify:section:load' listener plus three setTimeout(initArrows, ...)
  // calls - so each subsequent shopify:section:load event ran boot() (and
  // initArrows()) once per copy, compounding over the page's life. This
  // guard - the same pattern already used by upk-quickview.js and
  // upk-currency.js - makes every copy after the first a fast no-op: the
  // browser still fetches the tag (an instant cache hit, not a new network
  // request) but none of the real work below runs more than once.
  if(window.__upkPdpLoaded) return;
  window.__upkPdpLoaded = true;

  // Real cart total (in paise) required before the customer can reach checkout, // must stay in sync with the same threshold used in snippets/cart-drawer.liquid
  // and sections/main-cart-footer.liquid. Reads the single shared value set in
  // layout/theme.liquid, falling back to the same literal if that global isn't
  // present for any reason.
  var UPK_MIN_ORDER_PAISE = (typeof window.UPK_MIN_ORDER_PAISE === 'number') ? window.UPK_MIN_ORDER_PAISE : 15000; /* OPEN-ITEMS 128 (D37): ₹150 after discounts; below it, Buy it now lands on the cart page with the gate */
  function upkRoot(){ return (window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root)||'/'; }

  // Renders the cart drawer in place after a successful /cart/add.js call,
  // instead of a full page reload. Mirrors the same proven pattern already
  // used by upk-charm-bar.js's openCart() and
  // up-cart-drawer.js's applyRender(): wait for the <cart-drawer> custom
  // element to be ready, then call renderContents() with the sections
  // payload - Dawn's own renderContents() opens the drawer itself (see the
  // note on openCartDrawer below), so nothing further is needed here.
  // Previously the PDP's own Add to Bag button was the one path in the
  // whole theme that reloaded the page instead of doing this - which is
  // why the item only became visible once that reload finished (and why
  // a manual refresh looked like it "fixed" it: it was doing the same
  // reload, just sooner).
  // When Add to Bag is pressed inside the Quick View panel (which loads this
  // same PDP markup), close that panel first. The Quick View overlay/panel sit
  // at z-index 9998/9999, above the cart drawer (z-index 1000), so without this
  // the cart drawer would open hidden behind Quick View. The old full-page
  // reload closed Quick View as a side effect; now that Add to Bag renders the
  // drawer in place, it has to be closed explicitly. No-op on a normal PDP.
  function closeQuickViewIfOpen(){
    var qv=document.querySelector('.upk-qv.open');
    if(!qv) return;
    var x=qv.querySelector('.upk-qv-x');
    if(x) x.click();
  }

  function openCartDrawer(res){
    var root_=upkRoot();
    function withDrawer(cb){
      var existing=document.querySelector('cart-drawer');
      if(!existing){ cb(null); return; }
      if(window.customElements&&customElements.get('cart-drawer')){ cb(existing); return; }
      var done=false;
      function finish(){ if(done)return; done=true; cb(document.querySelector('cart-drawer')); }
      if(window.customElements&&customElements.whenDefined){
        customElements.whenDefined('cart-drawer').then(finish).catch(finish);
      }
      setTimeout(finish,700);
    }
    // Dawn's own CartDrawer.renderContents() (assets/cart-drawer.js) already
    // calls this.open() itself at the end, on its own setTimeout - so this
    // used to ALSO force the animate/active classes via a double-rAF, plus
    // call drawer.open() again after 500ms as a fallback. Two independent
    // callers converging on open() raced Dawn's own transitionend listener
    // (which trapFocus()'s the drawer once the CSS transition finishes)
    // against the DOM swap from our other refresh triggers, producing an
    // intermittent "Cannot read properties of null (reading
    // 'querySelectorAll')" in Dawn's getFocusableElements. Just calling
    // renderContents() and letting Dawn's own open() run once, un-raced,
    // removes that race entirely - the drawer still opens exactly the same,
    // one call instead of two.
    function apply(state){
      withDrawer(function(drawer){
        if(!drawer){ window.location.href=root_+'cart'; return; }
        try{ drawer.renderContents(state); }catch(e){}
        if(window.publish&&window.PUB_SUB_EVENTS){ try{ publish(PUB_SUB_EVENTS.cartUpdate,{source:'upk-pdp',cartData:res}); }catch(e){} }
      });
    }
    if(res.sections&&res.sections['cart-drawer']){ apply(res); return; }
    fetch(root_+'?sections=cart-drawer,cart-icon-bubble',{headers:{'Accept':'application/json'}})
      .then(function(r){return r.json();})
      .then(function(sec){ apply({id:res.items?res.items[0].id:res.id,sections:sec}); })
      .catch(function(){ window.location.href=root_+'cart'; });
  }

  function init(root){
    if(root.dataset.upkInit) return; root.dataset.upkInit='1';
    var main=root.querySelector('[data-upk-main] img');
    var imgs=[]; try{imgs=JSON.parse(root.querySelector('[data-upk-images]').textContent||'[]');}catch(e){}
    var alts=[]; try{alts=JSON.parse((root.querySelector('[data-upk-alts]')||{}).textContent||'[]');}catch(e){} /* P13d (D5): one alt per gallery image, "<title>, image n" where admin has none */
    var idx=0;
    root.querySelectorAll('[data-upk-thumb]').forEach(function(t,j){ if(t.classList.contains('active')) idx=j; }); /* P13a.1: the server marks the thumb of the selected variant's image active */
    /* P7.2: the main image carries a srcset (400 to 1200), so a swap must rewrite the srcset too or the browser keeps the old picture.
       Shopify image URLs take the width as a query parameter, so the candidates are derived from the one URL. */
    function setMain(url){
      if(!main) return;
      var u=String(url||''); main.src=u;
      if(!main.hasAttribute('srcset')) return;
      if(/[?&]width=\d+/.test(u)){ main.srcset=[400,600,800,1000,1200].map(function(w){ return u.replace(/([?&])width=\d+/,'$1width='+w)+' '+w+'w'; }).join(', '); }
      else { main.removeAttribute('srcset'); }
    }
    function show(i){
      if(!imgs.length||!main) return;
      idx=(i+imgs.length)%imgs.length; setMain(imgs[idx]); if(main&&alts[idx]) main.alt=alts[idx];
      root.querySelectorAll('[data-upk-thumb]').forEach(function(t,k){t.classList.toggle('active',k===idx);});
    }
    root.querySelectorAll('[data-upk-thumb]').forEach(function(t,k){t.addEventListener('click',function(){show(k);});});
    // Builders ask the gallery to show the image of the chosen finish (upk-band-charm-builder.js).
    root.addEventListener('upk:gallery:show',function(e){ var src=(e.detail&&e.detail.src)||''; var want=src.split('?')[0].replace(/^https?:/,''); if(!want) return; for(var k=0;k<imgs.length;k++){ if(String(imgs[k]).split('?')[0].replace(/^https?:/,'')===want){ show(k); return; } } /* not in this product's gallery: show the finish's own photo and clear the thumb highlight */ if(main){ setMain(src); root.querySelectorAll('[data-upk-thumb]').forEach(function(t){t.classList.remove('active');}); } });
    var prev=root.querySelector('[data-upk-prev]'),next=root.querySelector('[data-upk-next]');
    if(prev)prev.addEventListener('click',function(){show(idx-1);});
    if(next)next.addEventListener('click',function(){show(idx+1);});
    var variants=[]; try{variants=JSON.parse(root.querySelector('[data-upk-variants]').textContent||'[]');}catch(e){}
    var idInput=root.querySelector('[data-upk-variant-id]');
    var qtyInput=root.querySelector('[data-upk-qty]');
    var atc=root.querySelector('[data-upk-atc]');
    var lbl=root.querySelector('[data-upk-atc-label]');
    /* P4.7 (Q16): every size-guide link on the page (How to measure, the Size guide tab) opens the size guide page in a new tab at this piece type's card. */
    (function(){ var sgEl=document.querySelector('[data-upk-size-anchor]'); var sgA=sgEl?(sgEl.getAttribute('data-upk-size-anchor')||''):''; root.querySelectorAll('a[href^="/pages/size-guide"]').forEach(function(a){ var h=a.getAttribute('href')||''; if(sgA&&h.indexOf('#')===-1) a.setAttribute('href','/pages/size-guide'+sgA); a.setAttribute('target','_blank'); a.setAttribute('rel','noopener'); }); })();
    // APO (Mageworx) products: the app renders its own Add to cart inside the form and posts the chosen
    // option plus its add-on line itself. Our JSON add would drop both (Phase 7 QA), so on those
    // products the app button is the only Add to cart: ours is hidden and the app's is styled like ours.
    function apoButton(){ return root.querySelector('.mw-apo-add-to-cart-custom'); }
    (function apoHandoff(){
      var tries=0;
      function check(){
        var apo=apoButton();
        if(apo){
          apo.classList.add('upk-atc','upk-atc-primary','upk-atc--apo');
          root.setAttribute('data-upk-apo','true');
          var cta=root.querySelector('.upk-cta'); if(cta) cta.classList.add('upk-cta--apo');
          return;
        }
        if(++tries<60) setTimeout(check,250);
      }
      check();
    })();
    var buynow=root.querySelector('[data-upk-buynow]');
    var buynowLbl=root.querySelector('[data-upk-buynow-label]');
    var curV=null;
    var giftBox=root.querySelector('[data-upk-giftbox]');
    var initBox=root.querySelector('[data-upk-initbox]');
    function qty(){var n=parseInt(qtyInput&&qtyInput.value,10);return (n&&n>0)?n:1;}
    function clean(s){return String(s==null?'':s).replace(/<[^>]*>/g,'');}
    function money(cents){var base=clean((curV&&curV.price)||'₹');var p=((base.match(/^[^0-9]*/)||[''])[0]||'₹').replace(/\s+$/,'');return p+'\u00a0'+Math.round(cents/100).toLocaleString('en-IN');}
    function giftBoxOn(){
      if(!giftBox) return false;
      var c=giftBox.querySelector('[data-upk-giftbox-check]');
      return !!(c&&c.checked);
    }
    function giftBoxPrice(){
      if(!giftBoxOn()) return 0;
      var t=parseInt(giftBox.dataset.giftPrice,10)||0;
      if(window.upkGiftAddonPrice) t+=window.upkGiftAddonPrice(giftBox)||0;
      return t;
    }
    function initLetterPrice(){
      if(!initBox||!window.upkInitLetterPrice) return 0;
      return window.upkInitLetterPrice(initBox)||0;
    }
    function addonTotal(){
      return giftBoxPrice()+initLetterPrice();
    }
    function selected(){
      var vals=[];
      root.querySelectorAll('[data-upk-opt]').forEach(function(el){
        if(el.type==='radio'){ if(el.checked) vals[+el.dataset.optIndex]=el.value; }
        else { vals[+el.dataset.optIndex]=el.value; }
      });
      return vals;
    }
    function match(vals){return variants.find(function(v){return v.options.every(function(o,i){return o===vals[i];});});}
    function isZero(v){ return !v || !v.priceN || v.priceN<=0; }
    function renderCta(){
      if(!curV) return;
      var zero=isZero(curV);
      if(lbl){
        var c=(atc&&atc.dataset.upkCta)||'Add to bag';
        if(!curV.available){ lbl.textContent='Sold out'; }
        else if(zero){ lbl.textContent='Currently Unavailable'; }
        else {
          /* P4.1 (B04): the price sits in its own span so the stylesheet can drop it under the label on narrow screens. */
          lbl.textContent='';
          lbl.appendChild(document.createTextNode(c));
          var sep=document.createElement('span'); sep.className='upk-atc-sep'; sep.textContent=' \u00b7 ';
          var pr=document.createElement('span'); pr.className='upk-atc-price'; pr.textContent=money((curV.priceN*qty())+addonTotal());
          lbl.appendChild(sep); lbl.appendChild(pr);
        }
      }
      if(atc){ atc.disabled = !curV.available || zero; }
      if(buynow){ buynow.disabled = !curV.available || zero; }
    }
    function update(){
      var v=match(selected()); if(!v) return; curV=v;
      if(idInput) idInput.value=v.id;
      var sp=root.querySelector('[data-upk-sp]'); if(sp) sp.innerHTML=v.price;
      var mrp=root.querySelector('[data-upk-mrp]'); var off=root.querySelector('[data-upk-off]');
      if(mrp){mrp.style.display=v.compare?'':'none';if(v.compare)mrp.innerHTML=v.compare;}
      if(off) off.style.display=v.compare?'':'none';
      /* P3.4: the "You save" line above the title follows the variant (hidden when the variant has no real compare-at). */
      var sw=root.querySelector('[data-upk-save-wrap]'); if(sw){ var cN=v.compareN||0; if(cN>v.priceN){ sw.hidden=false; var sa=sw.querySelector('[data-upk-save-amt]'); if(sa) sa.textContent=money(cN-v.priceN); } else { sw.hidden=true; } }
      root.querySelectorAll('[data-upk-opt]').forEach(function(el){
        if(el.type==='radio'&&!el.checked) return;
        var s=root.querySelector('[data-upk-sel="'+el.dataset.optIndex+'"]'); if(s) s.textContent=String(el.value).replace(/Rosegold/g,'Rose gold').replace(/rosegold/g,'rose gold');
      });
      syncGallery(v,true);
      applyFinish(v.finish);
      renderCta();
    }
    /* P13b (Priyal's decision 5, 20 Oct 2026): the spec strip's Base and finish line follows the variant. The strip prints one line per
       finish (data-upk-spec-lines, snippets/upk-spec-strip) and each variant carries its finish in the variants JSON; a strip fixed by a
       metafield (data-upk-spec-fixed) is left alone. */
    function applyFinish(f){
      var strip=document.getElementById('upk-spec'); if(!strip||!f||strip.getAttribute('data-upk-spec-fixed')==='true') return;
      var lines={}; try{ lines=JSON.parse(strip.getAttribute('data-upk-spec-lines')||'{}'); }catch(e){ return; }
      var L=lines[f]; if(!L) return;
      var base=strip.querySelector('[data-upk-spec-base]'); if(base&&L.base) base.textContent=L.base;
      var row=strip.querySelector('[data-upk-spec-plating]'); if(row){ var dd=row.querySelector('dd'); if(L.plating){ row.hidden=false; if(dd) dd.textContent=L.plating; } else { row.hidden=true; } }
      strip.setAttribute('data-upk-spec-finish',f);
      /* P13e-delta.3 B6: the first feature pill follows the same finish */
      var pf=root.querySelector('[data-upk-pill-finish]')||document.querySelector('[data-upk-pill-finish]'); if(pf){ var pm={'925':'925 sterling silver','rose gold':'18K rose gold plating','silver':'316L stainless steel'}; pf.textContent=pm[f]||'18K gold plating'; }
    }
    /* Swatch to image (restore list 9): jump the gallery to the variant image so the thumbnail strip (the only gallery in quick view) follows the colour.
       P13a.1: also run once on init (quiet: no thumb scroll), so the picture, the swatch and the price agree even when the server-rendered
       selection and the gallery disagree (a cached section, a ?variant= on a variant with no image). */
    function syncGallery(v,scrollThumb){
      if(!v||!v.img) return;
      var vb=String(v.img).split("?")[0]; var k=-1;
      for(var q=0;q<imgs.length;q++){ if(String(imgs[q]).split("?")[0]===vb){ k=q; break; } }
      if(k>-1){ if(k!==idx){ show(k); } var th=root.querySelectorAll("[data-upk-thumb]")[k]; if(th){ var strip=th.parentNode; if(strip&&strip.scrollWidth>strip.clientWidth){ try{ strip.scrollTo({left:Math.max(0,th.offsetLeft-(strip.clientWidth-th.offsetWidth)/2),behavior:scrollThumb?'smooth':'auto'}); }catch(e){ strip.scrollLeft=Math.max(0,th.offsetLeft-(strip.clientWidth-th.offsetWidth)/2); } } } }
      else if(main){ setMain(v.img); }
    }
    root.querySelectorAll('[data-upk-opt]').forEach(function(el){el.addEventListener('change',update);});
    if(giftBox) giftBox.addEventListener('change',renderCta);
    if(initBox) initBox.addEventListener('change',renderCta);
    function setQty(n){if(n<1)n=1;if(qtyInput)qtyInput.value=n;renderCta();}
    var qm=root.querySelector('[data-upk-qm]'),qp=root.querySelector('[data-upk-qp]');
    if(qm)qm.addEventListener('click',function(){setQty(qty()-1);});
    if(qp)qp.addEventListener('click',function(){setQty(qty()+1);});
    if(qtyInput){qtyInput.addEventListener('input',renderCta);qtyInput.addEventListener('change',function(){setQty(qty());});}
    function bumpBubble(){try{fetch('/cart.js',{headers:{'Accept':'application/json'}}).then(function(r){return r.json();}).then(function(c){var b=document.querySelector('#cart-icon-bubble');if(!b)return;var spans=b.querySelectorAll('.cart-count-bubble span');if(spans.length){spans.forEach(function(s){if(s.getAttribute('aria-hidden')==='true'||!s.className)s.textContent=c.item_count;});}});}catch(e){}}
    function resetAddons(){
      if(giftBox&&window.upkGiftAddonsReset) window.upkGiftAddonsReset(giftBox);
      if(initBox&&window.upkInitLetterReset) window.upkInitLetterReset(initBox);
    }
    function buildCartItems(vid){
      var items=[{id:vid,quantity:qty()}];
      if(giftBoxOn()){
        var gvid=parseInt(giftBox.dataset.giftVariantId,10);
        if(gvid){
          var gProps={};
          var msgEl=giftBox.querySelector('[data-upk-giftbox-msg]');
          if(msgEl&&msgEl.value.trim()) gProps['Gift Message']=msgEl.value.trim();
          items.push({id:gvid,quantity:1,properties:gProps});
        }
        if(window.upkGiftAddonItems) items=items.concat(window.upkGiftAddonItems(giftBox));
      }
      if(initBox&&window.upkInitLetterOn&&window.upkInitLetterOn(initBox)&&window.upkInitLetterItem){
        var initItems=window.upkInitLetterItem(initBox)||[];
        if(initItems.length){
          var pz='pz-'+Date.now();
          // The base line lists the letters ("S + R", repeated per quantity) so the drawer, checkout and
          // the cart guard (assets/upk-cart-guard.js) treat base plus letters as one piece.
          var pzLabels=[];
          initItems.forEach(function(it){ var L=(it.properties&&it.properties['Initial Letter'])||''; var n=parseInt(it.quantity,10)||1; for(var k=0;k<n;k++){ if(L) pzLabels.push(L); } });
          var headProps={'_pzid':pz,'_pz_head':'true'};
          if(pzLabels.length) headProps['Personalisation']=pzLabels.join(' + ');
          items[0].properties=Object.assign({},items[0].properties||{},headProps);
          initItems.forEach(function(it){ it.properties=Object.assign({},it.properties||{},{'_pzid':pz}); });
          items=items.concat(initItems);
        }
      }
      return items;
    }
    if(atc){atc.addEventListener('click',function(){
      if(root.getAttribute('data-upk-apo')==='true'){ var apoBtn=apoButton(); if(apoBtn) apoBtn.click(); return; }
      if(atc.disabled||!curV||!curV.available||isZero(curV)) return;
      var vid=(idInput&&idInput.value)||(curV&&curV.id); if(!vid) return;
      if(initBox&&window.upkInitLetterValid&&!window.upkInitLetterValid(initBox)) return;
      var items=buildCartItems(vid);
      atc.disabled=true; if(lbl)lbl.textContent='Adding\u2026';
      fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},cache:'no-store',body:JSON.stringify({items:items,sections:'cart-drawer,cart-icon-bubble',sections_url:window.location.pathname})})
        .then(function(r){return r.json();})
        .then(function(d){
          if(d&&d.status){if(lbl)lbl.textContent='Unavailable';setTimeout(function(){atc.disabled=false;renderCta();},1500);return;}
          resetAddons();
          if(lbl)lbl.textContent='\u2713 Added to Bag';
          closeQuickViewIfOpen();
          openCartDrawer(d);
          setTimeout(function(){atc.disabled=false;renderCta();},900);
        })
        .catch(function(){atc.disabled=false;renderCta();});
    });}
    if(buynow){buynow.addEventListener('click',function(){
      if(buynow.disabled||!curV||!curV.available||isZero(curV)) return;
      var vid=(idInput&&idInput.value)||(curV&&curV.id); if(!vid) return;
      if(initBox&&window.upkInitLetterValid&&!window.upkInitLetterValid(initBox)) return;
      var items=buildCartItems(vid);
      var origLbl=buynowLbl?buynowLbl.textContent:'Buy it now';
      function fail(){
        if(buynowLbl)buynowLbl.textContent='Unavailable';
        setTimeout(function(){buynow.disabled=false;if(buynowLbl)buynowLbl.textContent=origLbl;},1500);
      }
      buynow.disabled=true; if(buynowLbl)buynowLbl.textContent='Processing\u2026';
      fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},cache:'no-store',body:JSON.stringify({items:items})})
        .then(function(r){return r.json();})
        .then(function(d){
          if(d&&d.status){ fail(); return; }
          resetAddons();
          fetch('/cart.js',{headers:{'Accept':'application/json'},cache:'no-store'})
            .then(function(r2){return r2.json();})
            .then(function(cart){
              var root_=upkRoot();
              if(cart&&cart.total_price>=UPK_MIN_ORDER_PAISE){
                window.location.href=root_+'checkout';
              } else {
                try{ sessionStorage.setItem('upkOpenCartOnLoad','1'); }catch(e){}
                window.location.href=root_+'cart';
              }
            })
            .catch(function(){
              window.location.href=upkRoot()+'cart';
            });
        })
        .catch(fail);
    });}
    root.querySelectorAll('[data-upk-acc-head]').forEach(function(h){
      h.addEventListener('click',function(){h.closest('[data-upk-acc]').classList.toggle('open');});
    });
    curV=match(selected())||variants[0]||null;
    syncGallery(curV,false);
    renderCta();
  }
  function injectArrowCSS(){
    if(document.getElementById('upkArrowCSS'))return;
    var s=document.createElement('style');s.id='upkArrowCSS';
    s.textContent='.shopify-section-group-header-group,.section-header{position:relative;z-index:50}.upk-stk,.related-products,product-recommendations{position:relative;z-index:0}.upk-arrow{position:absolute;top:36%;transform:translateY(-50%);z-index:6;display:none;place-items:center;width:42px;height:42px;border-radius:50%;border:1px solid var(--upk-line);background:var(--upk-cream);color:var(--upk-purple);font-size:22px;line-height:1;cursor:pointer;box-shadow:0 4px 14px rgba(var(--upk-purple-rgb), .14);transition:background .2s,color .2s}.upk-arrow:hover{background:var(--upk-purple);color:var(--upk-cream)}.upk-arrow--prev{left:2px}.upk-arrow--next{right:2px}@media(max-width:749px){.upk-arrow{width:34px;height:34px;font-size:18px;top:30%}}';
    document.head.appendChild(s);
  }
  function initArrows(){
    injectArrowCSS();
    var grids=document.querySelectorAll('.upk-stk .grid,.related-products .grid,product-recommendations .grid');
    grids.forEach(function(grid){
      if(grid.dataset.upkArrows)return; grid.dataset.upkArrows='1';
      var host=grid.parentNode; if(!host)return;
      if(window.getComputedStyle(host).position==='static'){host.style.position='relative';}
      function mk(dir){
        var b=document.createElement('button');
        b.type='button'; b.className='upk-arrow upk-arrow--'+dir;
        b.setAttribute('aria-label',dir==='prev'?'Previous':'Next');
        b.innerHTML=dir==='prev'?'‹':'›';
        b.addEventListener('click',function(e){e.preventDefault();var amt=Math.max(160,grid.clientWidth*0.8);grid.scrollBy({left:dir==='prev'?-amt:amt,behavior:'smooth'});});
        return b;
      }
      var pv=mk('prev'),nx=mk('next');
      host.appendChild(pv); host.appendChild(nx);
      function upd(){
        var scrollable=grid.scrollWidth-grid.clientWidth;
        if(scrollable<6){pv.style.display='none';nx.style.display='none';return;}
        pv.style.display=grid.scrollLeft>6?'grid':'none';
        nx.style.display=grid.scrollLeft<scrollable-6?'grid':'none';
      }
      grid.addEventListener('scroll',upd);
      window.addEventListener('resize',upd);
      upd(); setTimeout(upd,400);
    });
  }
  function maybeAutoOpenCart(){
    var flag;
    try{ flag = sessionStorage.getItem('upkOpenCartOnLoad'); }catch(e){ flag = null; }
    if(!flag) return;
    try{ sessionStorage.removeItem('upkOpenCartOnLoad'); }catch(e){}
    function tryOpen(){
      var drawer=document.querySelector('cart-drawer');
      if(drawer&&typeof drawer.open==='function'){ drawer.open(); }
    }
    if(window.customElements&&customElements.whenDefined){
      customElements.whenDefined('cart-drawer').then(tryOpen).catch(tryOpen);
    } else {
      setTimeout(tryOpen,300);
    }
  }
  function boot(){document.querySelectorAll('[data-upk-pdp]').forEach(init);initArrows();maybeAutoOpenCart();}
  if(document.readyState!=='loading')boot();else document.addEventListener('DOMContentLoaded',boot);
  document.addEventListener('shopify:section:load',boot);
  setTimeout(initArrows,800);setTimeout(initArrows,1800);setTimeout(initArrows,3500);
})();
